import ACTION from '../action_constant';
import moment from 'moment';

function requestAnItem(state = {} , action){
  switch (action.type) {

    case ACTION.REQUEST_AN_ITEM.STORE_REQUEST_DETAILS:
        if(!("isIWillMeetCarrierAtDelivery" in action.data))
        {
          action.data.isIWillMeetCarrierAtDelivery = true
        }
        if(!("deliveryUser" in action.data))
        {
          action.data.deliveryUser = {}
        }
        if(!("deliveryDate" in action.data))
        {
            action.data.deliveryDate = moment().startOf('day').unix() *1000 + ((8*24*60*60*1000) - 60000);
        }
        return Object.assign({}, state, action.data);

    case ACTION.REQUEST_AN_ITEM.CLEAR_REQUEST_DETAILS:
          return Object.assign({});

    default:
    return state ;
  }
}

export default requestAnItem;



// WEBPACK FOOTER //
// app/request_an_item/request_an_item_reducer.jsx